<ps-ui-modal size="lg" class="sup-group-modal">
  <h5 psUiModalTitle class="modal-text-title">Supplier Grouping</h5>
  <ps-ui-modal-body>
    <div>
      <p>Group Name</p>
      <input
        type="text"
        class="form-control"
        placeholder="Enter Name"
        name="name"
        [(ngModel)]="supplierGroup.groupName"
      />
    </div>
    <div>
      <p>CPI</p>
      <input
        [disabled]="cpiOverrideEnabled"
        type="number"
        class="form-control"
        [(ngModel)]="supplierGroup.cpi"
        name="cpi"
        placeholder="Enter CPI"
        [ngClass]="{ 'input-error': !isCpiConfirmed }"
        (input)="validateGroupSuppliersCPI($event)"
        psUiInputDecimalRestriction
      />
    </div>
    <div>
      <div class="row">
        <div class="col-8">
          <p>Grouped Suppliers</p>
        </div>
        <div class="col-4">
          <label class="mb-1">
            Custom Allocation %
            <ps-ui-slider
              [selected]="supplierGroup.isCustomAllocation"
              (selectedChange)="
                supplierGroup.isCustomAllocation = $event;
                distributeAllocation(true)
              "
            ></ps-ui-slider>
          </label>
        </div>
      </div>
      <div
        class="row"
        *ngFor="let supplier of selectedSuppliers; let i = index"
      >
        <div class="col-8">
          <button psUiButton class="supplier-button">
            {{ supplier.name }}
            <i
              class="fa fa-times-circle-o icon-remove-supplier"
              (click)="removeSupplierFromGroup(supplier)"
            ></i>
          </button>
        </div>
        <div class="col-4">
          <input
            type="text"
            class="form-control color-patch mb-0"
            [(ngModel)]="supplier.allocation"
            [disabled]="!supplierGroup.isCustomAllocation"
            psUiInputRestriction="[0-9]"
            psUiToNumber
            maxlength="3"
            minlength="1"
            max="100"
          />
        </div>
      </div>
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer position="center">
    <div class="row modal-style" *ngIf="!isCpiConfirmed">
      <div class="col-xs-12 text-center">
        <p>
          Please confirm the Supplier Grouping CPI you have entered are
          accurate.
        </p>
      </div>
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="save-button"
          psUiButton
          (click)="onConfirm()"
        >
          Confirm
        </button>
      </div>
    </div>
    <div class="row w-100">
      <div class="d-flex justify-content-end">
        <button
          psUiButton
          [outline]="true"
          class="me-3 save-as-template"
          (click)="saveGroupTemplate()"
        >
          Save Supplier Group as Template
        </button>
        <button psUiButton class="save-button" (click)="saveSupplierGroup()">
          Apply group for survey
        </button>
      </div>
    </div>
  </ps-ui-modal-footer>
</ps-ui-modal>
